export default '00000000-0000-0000-0000-000000000000';


//////////////////
// WEBPACK FOOTER
// /var/www/html/web/app/themes/wakanda/node_modules/uuid/dist/esm-browser/nil.js
// module id = 27
// module chunks = 0 1 2 3 4 5 6 7